import { useState, useCallback } from 'react'
import './App.css'
import { Editor } from './components/Editor'
import { Output, TranspileError } from './components/Output'
import { Examples } from './components/Examples'
import { Share, getCodeFromUrl } from './components/Share'
import { Logo } from './components/Logo'
import { Footer } from './components/Footer'
import { transpile } from 'jertscript'

const defaultCode = `// Bienvenue dans Jertscript! 🥐
// Welcome to Jertscript!

croissant greeting = "Bonjour, le monde!";
dire(greeting);

// Variables (croissant = const, baguette = let)
baguette count = 0;
pendant (count < 3) {
  dire("Vive la France!");
  count = count + 1;
}

// Functions
fonction add(a, b) {
  retourner a + b;
}

dire(add(2, 3));
`

function App() {
  const [code, setCode] = useState(() => {
    // Load code from URL hash on initial render
    const urlCode = getCodeFromUrl();
    return urlCode !== null ? urlCode : defaultCode;
  })

  // Transpile function to pass to Output component
  const handleTranspile = useCallback((source: string): { js: string; errors: TranspileError[] } => {
    try {
      const result = transpile(source);
      return {
        js: result.js,
        errors: result.errors.map(err => ({
          message: err.message,
          line: err.line
        }))
      };
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : String(err);
      return {
        js: '',
        errors: [{ message: errorMessage, line: 0 }]
      };
    }
  }, []);

  return (
    <div className="app">
      <div className="app-frame">
        <header className="header">
          <div className="header-content">
            <Logo />
            <Share code={code} />
          </div>
        </header>

        <main className="main">
          <div className="editor-panel">
            <div className="panel-header">
              <span>Jertscript</span>
              <Examples onSelect={setCode} />
            </div>
            <Editor
              value={code}
              onChange={setCode}
              placeholder="// Write your Jertscript code here..."
            />
          </div>

          <div className="output-panel">
            <Output
              code={code}
              transpile={handleTranspile}
              debounceMs={200}
            />
          </div>
        </main>

        <Footer />
      </div>
    </div>
  )
}

export default App
